module.exports = __webpack_public_path__ + "img/messe_Bistro.66ef98c8.gif";